<template>
    <div class="grid-chat-window" ref="gridChatWindow">
        <GridContactList
            :contact="contact"
            :contactList="contactList"
            :toggle-conversation="toggleConversation"
            :maxGridConversationsWidth="maxGridConversationsWidth"
            :minGridConversationsWidth="minGridConversationsWidth"
            @width="resizingGridConversation"
            @filters="$emit('filters', $event)"
            :filters="filters"
        />
        <template v-if="contact">
            <ChatWindow
                ref="chatWindow"
                :style="{ width: chatWindowWidth }"
                :is-live="isLive"
                :contact="contact"
                :key="contact._id"
            />
            <UserInfoWidget
                :is-live="isLive"
                :contact="contact"
                :maxUserInfoWidgetWidth="maxUserInfoWidgetWidth"
                :minUserInfoWidgetWidth="minUserInfoWidgetWidth"
                @width="resizingUserInfoWidget"
            />
        </template>
        <template v-else>
            <div class="no-active-conversation" :style="{ width: `calc(100% - ${this.gridConversationWidth}px)` }">
                <div class="no-active-conversation-content">
                    <NoActiveConversation />
                    <div class="no-active-conversation-content-title">{{ $t("chatWindow.thereIsNoChatContent") }}</div>
                    <div class="no-active-conversation-content-description">
                        {{ $t("chatWindow.thereIsNoChatContentDsc") }}
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>
<script>
import _ from "lodash";
import GridContactList from "./GridContactList.vue";
import ChatWindow from "./ChatWindow.vue";
import UserInfoWidget from "./UserInfoWidget.vue";
import NoActiveConversation from "./svg/NoActiveConversation.vue";
import { mapState } from "vuex";

let MIN_GRID_CONVERSATION_WIDTH = 400;
export default {
    name: "GridChatWindow",
    components: {
        NoActiveConversation,
        UserInfoWidget,
        GridContactList,
        ChatWindow,
    },
    props: {
        isLive: {
            type: Boolean,
            default: false,
        },
        filters: {
            type: Object,
            default: () => ({}),
        },
        contactList: {
            type: Array,
            default: () => [],
        },
        toggleConversation: {
            type: Function,
            default: () => _.noop,
        },
        contact: {
            type: Object,
            default: () => ({}),
        },
    },
    computed: {
        ...mapState({
            chatListToolbarLocked: (state) => state.chat.chatListToolbarLocked,
        }),
    },
    data: () => ({
        gridConversationWidth: 0,
        maxGridConversationsWidth: 0,
        minGridConversationsWidth: MIN_GRID_CONVERSATION_WIDTH,
        userInfoWidgetWidth: 0,
        maxUserInfoWidgetWidth: 0,
        minUserInfoWidgetWidth: 50,
        chatWindowWidth: `calc(100%)`,
    }),
    methods: {
        calcUserinfoWidgetWidth() {
            const wrapper = this.$refs.gridChatWindow;
            this.maxUserInfoWidgetWidth = wrapper.clientWidth * 0.3;
        },
        calcGridConversationWidth() {
            const wrapper = this.$refs.gridChatWindow;
            this.maxGridConversationsWidth = Math.max(wrapper.clientWidth * 0.45, MIN_GRID_CONVERSATION_WIDTH);
            // this.minGridConversationsWidth = wrapper.clientWidth * 0.2;
            this.minGridConversationsWidth = MIN_GRID_CONVERSATION_WIDTH;
            this.gridConversationWidth = this.maxGridConversationsWidth * 0.5;
        },
        resizeChatWindow() {
            this.chatWindowWidth = `calc(100% - ${this.gridConversationWidth + this.userInfoWidgetWidth}px)`;
        },
        resizingUserInfoWidget(width) {
            this.userInfoWidgetWidth = width;
            this.resizeChatWindow();
        },
        resizingGridConversation(width) {
            this.gridConversationWidth = width;
            this.resizeChatWindow();
        },
    },
    mounted() {
        this.calcGridConversationWidth();
        this.calcUserinfoWidgetWidth();
    },
    watch: {
        chatListToolbarLocked(isLocked) {
            if (isLocked) {
                MIN_GRID_CONVERSATION_WIDTH = 400;
                this.minGridConversationsWidth = MIN_GRID_CONVERSATION_WIDTH;
            } else {
                MIN_GRID_CONVERSATION_WIDTH = 510;
                this.minGridConversationsWidth = MIN_GRID_CONVERSATION_WIDTH;
            }
        },
    },
};
</script>
<style lang="scss" scoped>
.grid-chat-window {
    display: flex;
    width: 100%;
    height: 100%;

    .no-active-conversation {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        &-content {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            text-align: center;
            gap: 8px;
            color: #8796af; //TODO: color selector.
            overflow: hidden;

            &-title {
                font-size: 18px;
                font-weight: bold;
                margin-top: 10px;
            }

            &-description {
                font-size: 14px;
            }
        }
    }
}
</style>
